<template>
    <div>
        <Head title="Create Traffic source"/>
        <h1 class="mb-8 text-3xl font-bold">
            <Link class="text-indigo-400 hover:text-indigo-600" href="/traffic-sources">Traffic sources</Link>
            <span class="text-indigo-400 font-medium">/</span> Create
        </h1>
        <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="store">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2"
                                label="Traffic source name"/>
                    <select-input v-model="form.brand_id" :error="form.errors.brand_id"
                                  class="pb-8 pr-6 w-full lg:w-1/2" label="Brand">
                        <option v-for="(id, name) in brands" :value="id">{{ name }}</option>
                    </select-input>
                    <label class="pb-8 pr-6 w-full lg:w-full" for="remember">
                        <input id="remember" v-model="form.is_default" class="mr-1" type="checkbox" />
                        <span class="text-sm">is default traffic source</span>
                    </label>
                    <h5>Config</h5>
                    <Vue3JsonEditor
                        v-model="form.config"
                        :show-btns="false"
                        :expandedOnStart="true"
                        style="width: 100%"
                        @json-change="onChangeConfig"/>
                </div>
                <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create Traffic source
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import MultipleSelectInput from '@/Shared/MultipleSelectInput'
import TextareaInput from "@/Shared/TextareaInput";
import {Vue3JsonEditor} from 'vue3-json-editor'
import CheckboxInput from "@/Shared/CheckboxInput";

export default {
    components: {
        CheckboxInput,
        FileInput,
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        MultipleSelectInput,
        TextareaInput,
        Vue3JsonEditor
    },
    props: {
        brands: Object,
    },
    layout: Layout,
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                name: '',
                brand_id: '',
                is_default: false,
                config: ''
            }),
        }
    },
    methods: {
        store() {
            this.form.post('/traffic-sources')
        },
        onChangeConfig(value) {
            this.form.config = value;
        }
    },
}
</script>
